import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule, CheckboxModule, RadiobuttonModule } from '@lib/components';
import { TranslateModule } from '@ngx-translate/core';
import { StaticMsgModule, StaticMsgPipe } from '@lib/pipes';
import { CommonLibModule } from '@lib/services';
import { AswMasterStoreModule } from '@lib/store';
import { ConsiderationSupportDetailsModalComponent } from './consideration-support-details-modal.component';

@NgModule({
  declarations: [ConsiderationSupportDetailsModalComponent],
  providers: [StaticMsgPipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    RadiobuttonModule,
    ButtonModule,
    TranslateModule,
    StaticMsgModule,
    CommonLibModule,
    AswMasterStoreModule,
  ],
  exports: [ConsiderationSupportDetailsModalComponent],
})
export class ConsiderationSupportDetailsModalModule {}
